import type { SelectProps } from '@ztechapps/webui.input'
import * as React from 'react'
import { TemplateSelectCreatable } from '@ztechapps/webui.data-tools'
const templateCategory = 'discount_template'
const placeholder = 'Select a discount.'

export const DiscountSelect = (props: SelectProps) => {
  return <TemplateSelectCreatable templateCategory={templateCategory} placeholder={placeholder} {...props} />
}
